import React from "react";
import { ConfirmModal } from "../../../../boxes/ConfirmModal/ConfirmModal";

const BlacklistNumbersModal = ({
  onClose,
  onConfirm,
  chatIds,
  isConfirming,
}) => {
  return (
    <ConfirmModal
      isOpen
      onClose={onClose}
      title="Confirmation Required"
      onConfirm={onConfirm}
      onCancel={onClose}
      confirmTitle={"Yes"}
      cancelTitle={"No"}
      isConfirming={isConfirming}
    >
      {`Are you sure you want to block  ${
        chatIds.length === 1 ? "this chat" : "these chats"
      } ?`}
    </ConfirmModal>
  );
};

export default BlacklistNumbersModal;
